// Small date helpers shared by schoolSchedule.js (Adam) and
// kimberlySchedule.js (Kimberly) — split out so both compute "today"/"is
// this a weekend" the same way instead of drifting.

function toDateOnly(dateStr) {
  return new Date(dateStr + "T00:00:00");
}

function isWeekend(d) {
  const day = d.getDay();
  return day === 0 || day === 6;
}

// Local calendar date, NOT UTC — toISOString() converts to UTC first,
// which rolls over to "tomorrow" once it's past 8 PM Eastern (UTC-4/5).
// getFullYear/getMonth/getDate are all local-time already.
function fmt(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Literally tomorrow's calendar date — deliberately NOT the next school
// day. If tomorrow is a Saturday (or any other non-school day), callers
// should show "No school" for it rather than skipping ahead to the next
// school day. Carissa's call: on a Friday night this should say Sunday's
// "No school," not jump to Monday.
function tomorrowStr() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return fmt(d);
}

export { toDateOnly, isWeekend, fmt, tomorrowStr };
